import Button from '@/shared/Button/Button';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import { PlayCircleFilled, RollbackOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { ControlBar } from '../../ActivityComponents/ControlBar/ControlBar';

export function GameControlBar({
  state,
  actions,
  activityConf,
  parentDivRef,
  children,
}) {
  const fullscreenContext = useContext(FullscreenContext);
  return (
    <ControlBar
      className={fullscreenContext.state.isFullscreen ? 'fullscreen' : ''}
      parentDivRef={parentDivRef}
    >
      {children}
      {state.screen === 'GAME' && !activityConf ? (
        <Button size="small" onClick={actions.goToMainMenu}>
          <span className="text">Main menu </span>
          <RollbackOutlined />
        </Button>
      ) : null}
      {state.canRestart ? (
        <Button size="small" onClick={actions.restartGame}>
          <span className="text">Play again</span>
          <PlayCircleFilled />
        </Button>
      ) : null}
    </ControlBar>
  );
}
